import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import { GeoArea } from '@/types/GeoArea';
import { ReactNode } from 'react';

type GetPageTitleParams = {
    geoArea: GeoArea | undefined;
    geocoderFailed: boolean;
    hasFilteredResults: boolean;
    searchTerm: string;
};

export function getPageTitle({
    geoArea,
    geocoderFailed,
    hasFilteredResults,
    searchTerm,
}: GetPageTitleParams): ReactNode {
    // User searches for a location that does not match any geo area (geocoder failed) - e.g. "Anytown"
    if (geocoderFailed && searchTerm) {
        return (
            <FormattedMessage
                id="auctionsNearMe.noAuctionsFound"
                values={{ locationSearched: searchTerm }}
            />
        );
    }

    // User searches for a location via geocoder and returns NO results - e.g. "Akron"
    if (searchTerm && !hasFilteredResults) {
        return (
            <FormattedMessage
                id="auctionsNearMe.noAuctionsFound"
                values={{ locationSearched: searchTerm }}
            />
        );
    }

    // User searches for a location via geocoder and HAS results - e.g. "Cleveland"
    if (searchTerm && hasFilteredResults) {
        return (
            <FormattedMessage
                id="auctionsNearMe.customSearchPageTitle"
                values={{ locationSearched: searchTerm }}
            />
        );
    }

    // User navigates to a geo area page that has NO results
    if (geoArea?.pageTitle && !hasFilteredResults) {
        return (
            <FormattedMessage
                id="auctionsNearMe.noAuctionsFound"
                values={{ locationSearched: geoArea.geoAreaName }}
            />
        );
    }

    // User navigates to a geo area page with results
    if (geoArea?.pageTitle) {
        return geoArea.pageTitle;
    }

    // Default page title
    return <FormattedMessage id="auctionsNearMe.defaultPageTitle" />;
}
